import React from "react";
import BasicModal from "../../core/BaseComponents/Modal";
import deleteImg from '../../../assets/images/delete.png';
import { IoMdWarning } from "react-icons/io";

function DeleteCustomWelcomeMessage(props) {
  return (
    <BasicModal
      popupOpen={props?.deletePublishUnPublishPopUp}
      bodyMessage={<>
        <img src={deleteImg} alt="approve" className="w-40px" />
        <div className="delete-hotel mb-3">{props?.isPublishUnPublishDeletedRef?.current?.isPublishUnPublishDeletedModalData ?
          <div className="confirm-delete-hotel">
            <p>Do you really want to Delete Welcome Message for Room No "<b>{props?.isPublishUnPublishDeletedRef?.current?.isPublishUnPublishDeletedModalData.row.roomNo}</b>" ?</p>
            <p className="warning"><IoMdWarning /> Warning</p>
            <p>Room No "{props?.isPublishUnPublishDeletedRef?.current?.isPublishUnPublishDeletedModalData.row.roomNo}" Welcome Message will be permanently deleted <br />
              Deleting the specified Room Welcome Message can't be undone.
            </p>
            <p className="mt-3">To confirm deletion, type "Delete Room No {props?.isPublishUnPublishDeletedRef?.current?.isPublishUnPublishDeletedModalData.row.roomNo} Welcome Message"</p>
            <div className="form-group-hotel mt-3">
              <div className="floating-label">
                <input
                  id="deleteHotel"
                  placeholder=""
                  onChange={(e) => props?.setConfirmDeletePublishUnPublish(e.target.value)}
                />
                <label htmlFor="address">Delete Welcome Message</label>
              </div>
              {(props?.confirmDeletePublishUnPublish === "" && props?.confirmValidate) ? (
                <p className="text-start"><small className="required">Please Enter Delete Room No {props?.isPublishUnPublishDeletedRef?.current?.isPublishUnPublishDeletedModalData.row.roomNo} Welcome Message</small></p>
              ) : (props?.confirmDeletePublishUnPublish !== `Delete Room No ${props?.isPublishUnPublishDeletedRef?.current?.isPublishUnPublishDeletedModalData.row.roomNo} Welcome Message` && props?.confirmValidate) ? (
                <p className="text-start"><small className="required">Please Enter Delete Room No {props?.isPublishUnPublishDeletedRef?.current?.isPublishUnPublishDeletedModalData.row.roomNo} Welcome Message</small></p>
              ) : ""
              }
            </div>
          </div> :
          props?.isPublishUnPublishDeletedRef?.current?.userConformationModalData?.successMessage}</div>
      </>
      }
      footer={
        props?.isPublishUnPublishDeletedRef?.current?.isPublishUnPublishDeletedModalData ?
          {
            primaryButton: {
              buttonName: "Cancel",
              action: props?.popupCloseHandler
            },
            secondaryButton: {
              buttonName: "Delete",
              action: props?.deletePublishUnPublishHandler
            }
          } : {
            secondaryButton: {
              buttonName: "OK",
              action: props?.popupCloseHandler
            }
          }
      }
    />
  );
}

export default DeleteCustomWelcomeMessage;
